import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { createContext, useReducer, useMemo } from 'react';
import { SET_PATIENT_CERT_HISTORY } from './constant';
const initialState = {
  patientCertHistory: null
};
const initCertGlobalContext = {
  patientCertHistory: null
};
export const CertGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case SET_PATIENT_CERT_HISTORY:
      newState.patientCertHistory = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const CertGlobalContext = /*#__PURE__*/createContext(initCertGlobalContext);
export const CertGlobalDispatchContext = /*#__PURE__*/createContext({});
export const CertGlobalContextConsumer = CertGlobalContext.Consumer;
export const CertGlobalDispatchContextConsumer = CertGlobalDispatchContext.Consumer;
export const CertGlobalContextProvider = ({
  children
}) => {
  const [{
    patientCertHistory
  }, dispatchCert] = useReducer(CertGlobalContextReducer, initialState);
  const context = useMemo(() => ({
    patientCertHistory,
    dispatchCert
  }), [patientCertHistory, dispatchCert]);
  return /*#__PURE__*/React.createElement(CertGlobalContext.Provider, {
    value: context
  }, children);
};
export function withCertGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(CertGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(CertGlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default CertGlobalContext;